<div class="flexColumn" style="position: relative; width: 100%; height: 100%">


  <aik-3d-viewer
    #threeDViewer
    (fileLoadedDimension)="fileLoadedDimension = $event"
    (fileTotalDimension)="fileTotalDimension = $event"
    (loadingErrorMessage)="loadingErrorMessage = $event"
    (loadingWorkflowStatus)="loadingWorkflowStatus = $event; loadingWorkflowStatusChanged.emit($event)"
    (meshSelected)="selectedMeshInstanceId = $event; selectedMeshInstanceIdChanged.emit($event)"
    *ngIf="tdVisible"
    [fileBlob]="localBlob"
    style="width: 100%; flex: 1 1; height: 100%;">
  </aik-3d-viewer>

  <div
    *ngIf="loadingWorkflowStatus !== FileLoadingWorkflowEnum.COMPLETED && loadingWorkflowStatus !== FileLoadingWorkflowEnum.INIT"
    class="loaderPopup dx-overlay-content dx-loadpanel-content">
    <div
      *ngIf="loadingWorkflowStatus !== FileLoadingWorkflowEnum.ERROR && loadingWorkflowStatus !== FileLoadingWorkflowEnum.NO_FILE_FOUND"
      class="loaderPopupContent">
      <dx-load-indicator *ngIf="loadingWorkflowStatus !== FileLoadingWorkflowEnum.LOADING"
                         height="40"
                         id="medium-indicator"
                         width="40"
      ></dx-load-indicator>
      <span
        class="loadingStatusTitle">{{ "WIDGETS.THREE_DIM.LOADING_STATUS." + printLoadingStatus() | translate }}</span>
      <dx-progress-bar *ngIf="loadingWorkflowStatus === FileLoadingWorkflowEnum.LOADING"
                       [elementAttr]="{ 'aria-label': 'Progress Bar' }"
                       [max]="fileTotalDimension"
                       [min]="0"
                       [showStatus]="false"
                       [statusFormat]="format"
                       [value]="fileLoadedDimension"
                       id="loading-status"
                       width="80%">
      </dx-progress-bar>
    </div>
    <div *ngIf="loadingWorkflowStatus === FileLoadingWorkflowEnum.ERROR">
      <div class="loadingStatusTitle">{{ 'WIDGETS.THREE_DIM.LOADING_STATUS.ERRORS.FAILED_TO_LOAD' | translate }}</div>
      <dx-button
        (onClick)="reload3DItem()"
        icon="refresh"
        stylingMode="contained"
        text="{{ 'COMMON.RELOAD' | translate }}"
        type="default">
      </dx-button>
    </div>
  </div>
  <div
    *ngIf="(!!selectedMeshInstanceId || selectedMeshInstanceId === 0) && (!isWidget || !(!keyMeshesList.get(selectedMeshInstanceId!) || keyMeshesList.get(selectedMeshInstanceId!)?.length === 0))"
    class="measureDetailContainer">
    <div class="measureDetailBoxContainer">
      <div [style.background-color]="getStylizedCSSVariable('--dx-color-main-bg').concat('90')"
           class="dx-card measureDetailBox">
        <dx-scroll-view *ngIf="!!keyMeshesList.get(selectedMeshInstanceId)" direction="vertical">
          <dx-sortable
            (onReorder)="array_move(keyMeshesList.get(selectedMeshInstanceId)!, $event.fromIndex, $event.toIndex)"
            *ngIf="!isWidget"
            class="measureDetailList"
            handle="#movingHandle">
            <ng-container *ngTemplateOutlet="meshMeasure"></ng-container>
          </dx-sortable>
          <div *ngIf="isWidget" class="measureDetailList">
            <ng-container *ngTemplateOutlet="meshMeasure"></ng-container>
          </div>
        </dx-scroll-view>

        <ng-template #meshMeasure>
          <div *ngFor="let measure of keyMeshesList.get(selectedMeshInstanceId)" class="flexRow">
            <i *ngIf="!isWidget" class="vr-ic_fluent_re_order_dots_vertical_24_regular movingHandle"
               id="movingHandle"></i>
            <span>{{ measure.partitionName }} > {{ measure.deviceName }} > {{ measure.name }}: </span>
            <span style="text-align: right"><b>{{ appService.getParsedMetricValue(measure) }}</b> {{ measure.dataUnit }}</span>
            <dx-button
              (onClick)="deleteMeasure.emit({
              measureId: measure.id,
              mesh: selectedMeshInstanceId})"
              *ngIf="!isWidget"
              [stylingMode]="'text'"
              class="smallButton">
              <i class="vr-ic_fluent_delete_24_regular"></i>
            </dx-button>
          </div>
          <span
            *ngIf="!keyMeshesList.get(selectedMeshInstanceId!) || keyMeshesList.get(selectedMeshInstanceId!)?.length === 0">{{ 'COMMON.NO_DATA_INSERTED' | translate }}</span>
        </ng-template>


      </div>
    </div>
  </div>
</div>
